export enum SurveyPageEnum {
  SURVEY = 'survey',
  THANK_YOU = 'thankyou',
}

export type CommonProps = {
  pageIndex: number
  onNextPage: (nextQuestion: number) => void
}
